/**
 * ============================================================
 * KEJJA OS — Topbar
 * Greeting + date + notifications + avatar.
 * ============================================================
 */

import ThemeToggle from '@/components/ThemeToggle';
import NotificationBell from '@/components/NotificationBell';
import { useNotificationPump } from '@/hooks/useNotifications';
import { useAuth } from '@/hooks/useAuth';
import { MobileNavTrigger } from './MobileNav';

function greetingFor(hour: number): string {
  if (hour < 5) return 'Still up';
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  if (hour < 21) return 'Good evening';
  return 'Good night';
}

export function Topbar() {
  useNotificationPump();
  const { user } = useAuth();
  const now = new Date();
  const greeting = greetingFor(now.getHours());
  const firstName = user?.displayName?.split(' ')[0] ?? 'friend';
  const dateText = now.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <header className="h-16 border-b border-border bg-background flex items-center justify-between px-4 md:px-6 sticky top-0 z-30">
      <div className="flex items-center gap-3">
        <MobileNavTrigger />
        <div>
          <h1 className="text-base md:text-lg font-semibold text-foreground">
            {greeting}, {firstName}
            {now.getHours() < 12 ? ' ☀️' : ''}
          </h1>
          <p className="text-xs text-muted-foreground">{dateText}</p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <ThemeToggle />
        <NotificationBell />
        </div>
    </header>
  );
}

